var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Builder',{attrs:{"blocks":_vm.blocks,"context":_vm.context}}),_vm._v(" "),_c('NuxtChild')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }